<div ng-controller="registerActivityConfigController as vm" class="modal-view">
</div>